// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"banner_upload_thumbnail__WcCMt","small_thumbnail":"banner_upload_small_thumbnail__3MpDZ"};